import { duration as e } from "../../foundations/motion/motion-tokens.js";
import { useMotionPolicy as t } from "../../motion/useMotionPolicy.js";
import { useLayoutEffect as n, useRef as r } from "react";
import { animate as i } from "motion";
//#region src/components/button/useButtonWidth.ts
function a(a, o) {
	let s = r(null), c = r(null), l = r(null), u = r(null), d = r([]), { keyboard: f, reduced: p } = t();
	return n(() => {
		let t = s.current, n = c.current;
		if (!t || !n) return;
		l.current ??= t.style.width;
		let r = d.current.length ? Number.parseFloat(getComputedStyle(t).width) : u.current;
		for (let e of d.current) e.stop();
		d.current = [], t.style.width = l.current, n.style.width = "", n.style.maxWidth = "", n.style.flexShrink = "";
		let a = t.offsetWidth, m = n.offsetWidth;
		if (u.current = a, !o || r === null || r === a || f || p) return;
		n.style.width = `${String(m)}px`, n.style.maxWidth = "none", n.style.flexShrink = "0", t.style.width = `${String(r)}px`;
		let h = i(t, { width: a }, {
			duration: e.base / 1e3,
			ease: [
				.23,
				1,
				.32,
				1
			],
			onComplete: () => {
				t.style.width = l.current ?? "", n.style.width = "", n.style.maxWidth = "", n.style.flexShrink = "", d.current = [];
			}
		});
		d.current = [h];
	}, [
		a,
		o,
		f,
		p
	]), n(() => {
		let e = s.current, t = typeof ResizeObserver > "u" ? void 0 : new ResizeObserver(() => {
			e && !d.current.length && (u.current = e.offsetWidth);
		});
		return e && t?.observe(e), () => {
			t?.disconnect();
			for (let e of d.current) e.stop();
		};
	}, []), {
		buttonRef: s,
		contentRef: c
	};
}
//#endregion
export { a as useButtonWidth };
